module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-haze-0a0916fd.svg";